import React from 'react';
import styles from './pin-wheel-color.module.css';


const PinWheelColor = (props) => (
    <span className={styles.PinWheelColor}></span>
)

export default PinWheelColor;